export function getOptionalText(text?: string | null) {
  return text || 'None given';
}
